import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class EventSettings extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][EventSettings][getAll] organizationId and eventId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/settings`;
    }

    static list(item) {
        return item;
    }

    save(...args) {
        return this.constructor.save(this, ...args);
    }

    static save(objects, ...args) {
        let data = objects.toAPI();
        let url = this.getListUrl(...args);

        return fetcher.patch(url, { data });
    }

    toAPI() {
        // delete ID on data because pk is fake
        let result = super.toAPI();
        delete result.id;
        return result;
    }

    static getItemUrl(...args) {
        return this.getListUrl(...args);
    }
}
